import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {Environment} from '../environment/environment';

export class HttpFactory {

  static createTranslateHttpLoader(http: HttpClient) {
    const environmentConfig = Environment.environmentConfig();
    return new TranslateHttpLoader(http, environmentConfig.translateURL, environmentConfig.translateSuffix);
  }
}
